import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderComp } from "../TambahDaftarAset/HeaderComp";
import {
  InputFieldResponsive,
  SelectFieldResponsive,
} from "../../component/Utils";
import { Label, Button, Form } from "reactstrap";
import { editDataAction } from "../../config/redux/action";
import {
  PG_NAMA_ASET,
  PG_ALAMAT_ASET,
  PG_LUAS_TANAH ,
  PG_LUAS_BANGUNAN,
  PG_STATUS_ASET,
  PG_KETERANGAN,
  PG_PERUSAHAAN_ID,
  PG_LONGITUDE,
  PG_LATITUDE,
  PG_CREATE_BY_ID,
  PG_APPROVED_BY_ID,
  PG_UPDATED_BY_ID,
  PG_REJECTED_BY_ID,
  PG_CREATE_AT,
  PG_APPROVED_AT,
  PG_UPDATED_AT,
  PG_REJECTED_AT,
  BASE_URL,
  PG_TANAH_BANGUNAN,
  PG_KOORDINAT,
} from "../../constants";
import { useParams } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import Axios from "axios";
import { axiosConfig } from "../../utils/helper";
import LoadingTop from "../../component/LoadingTop";
import Perusahaan from "../Perusahaan";
import { Button as ButtonS } from "semantic-ui-react";

const ActionButton = () => {
  const batal = (e) => {
    e.preventDefault();
    window.history.back();
  };
  return (
    <div className="d-flex justify-content-end">
      <Button type="button" className="mr-3" onClick={(e) => batal(e)}>
        Batal
      </Button>
      <ButtonS type="submit" color="blue">
        Simpan
      </ButtonS>
    </div>
  );
};

export default () => {
  const { idDaftarAset } = useParams();
  const dispatch = useDispatch();
  const [daftarAset, setDaftarAset] = React.useState();

  const init = () => {
    const urlDaftarAset = `${BASE_URL}/daftar-aset/${idDaftarAset}`;
    const config = axiosConfig();
    Axios.get(urlDaftarAset, config).then((response) => {
      const pg = { ...response.data };
      setDaftarAset({ ...pg });
    });
  };


  React.useEffect(() => {
    init();
  }, []);

  const handleChange = (event, type) => {
    const { name, value } = event.target;
    setDaftarAset({ ...daftarAset, [name]: value });
    // dispatch({ type, data });
  };

  const handleChangeDate = (name, value, type) => {
    setDaftarAset({ ...daftarAset, [name]: value });
  };

  const user = useSelector((state) => state.main.dataUser);
  const dataUser = JSON.parse(localStorage.getItem("user"));

  const submit = (e) => {
    e.preventDefault();
    const param = {
      path: "daftar-aset",
      body: daftarAset,
      title: "Daftar Aset",
    };
    dispatch(editDataAction(param)).then((response) => window.history.back());
  };

  // if (Object.keys(pegawai).length === 0 && pegawai.constructor === Object) {
  if (!daftarAset) {
    return (
      <div className="w-100 d-flex justify-content-center my-5">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <>
      <LoadingTop />
      <HeaderComp title="Edit Aset" />
      <Form onSubmit={submit}>
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <hr />
                <div className="mb-3">
                  <InputFieldResponsive
                    label="Perusahaan"
                    inputType={{
                      value: daftarAset.perusahaan.nama,
                      disabled: true,
                      required: false,
                      name: "perusahaan",
                    }}
                    onChange={(e) => handleChange(e, PG_PERUSAHAAN_ID)}
                  />
                  <InputFieldResponsive
                    label="Nama Aset "
                    inputType={{
                      value: daftarAset.namaAset,
                      disabled: false,
                      required: true,
                      name: "namaAset",
                    }}
                    onChange={(e) => handleChange(e, PG_NAMA_ASET)}
                  />
                  <InputFieldResponsive
                    label="Alamat"
                    inputType={{
                      value: daftarAset.alamat,
                      disabled: false,
                      required: true,
                      name: "alamat",
                    }}
                    onChange={(e) => handleChange(e, PG_ALAMAT_ASET)}
                  />
                  <InputFieldResponsive
                    label="Koordinat"
                    inputType={{
                      value: daftarAset.koordinat,
                      disabled: false,
                      required: false,
                      name: "koordinat",
                    }}
                    onChange={(e) => handleChange(e, PG_KOORDINAT)}
                  />
                  {/* <InputFieldResponsive
                    label="Latitude"
                    inputType={{
                      value: daftarAset.latitude,
                      disabled: false,
                      required: false,
                      name: "latitude",
                    }}
                    onChange={(e) => handleChange(e, PG_LATITUDE)}
                  />
                  <InputFieldResponsive
                    label="Longitude"
                    inputType={{
                      value: daftarAset.longitude,
                      disabled: false,
                      required: false,
                      name: "longitude",
                    }}
                    onChange={(e) => handleChange(e, PG_LONGITUDE)}
                  /> */}
                  <InputFieldResponsive
                    label="Luas Tanah"
                    inputType={{
                      value: daftarAset.luasTanah,
                      disabled: false,
                      required: true,
                      name: "luasTanah",
                    }}
                    onChange={(e) => handleChange(e, PG_LUAS_TANAH)}
                  />
                  <InputFieldResponsive
                    label="Luas Bangunan"
                    inputType={{
                      value: daftarAset.luasBangunan,
                      disabled: false,
                      name: "luasBangunan",
                    }}
                    onChange={(e) => handleChange(e, PG_LUAS_BANGUNAN)}
                  />
                  <InputFieldResponsive
                    label="Tanah atau Bangunan"
                    inputType={{
                      value: daftarAset.tanahBangunan,
                      disabled: false,
                      name: "tanahBangunan",
                    }}
                    onChange={(e) => handleChange(e, PG_TANAH_BANGUNAN)}
                  />
                  <InputFieldResponsive
                    label="Status Aset"
                    inputType={{
                      value: daftarAset.statusAset,
                      disabled: false,
                      name: "statusAset",
                    }}
                    onChange={(e) => handleChange(e, PG_STATUS_ASET)}
                  />
                  <InputFieldResponsive
                    label="Keterangan"
                    inputType={{
                      value: daftarAset.keterangan,
                      disabled: false,
                      name: "keterangan",
                    }}
                    onChange={(e) => handleChange(e, PG_KETERANGAN)}
                  />
                </div>
                <hr />
                <ActionButton />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};
